module.exports = __webpack_public_path__ + "img/logo.9c0c3128.png";